import React, { useEffect } from 'react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import CartItem from './CartItem';

function CartPage() {
  const { cart, summary, loading, loadCart, clearCart } = useCart();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    
    // Only load cart if we don't have cart data yet
    if (!cart) {
      loadCart();
    }
  }, [isAuthenticated, navigate]);

  const handleClearCart = async () => {
    if (window.confirm('Are you sure you want to clear your cart?')) {
      await clearCart();
    }
  };

  const handleContinueShopping = () => {
    navigate('/products');
  };

  const handleCheckout = () => {
    // Future implementation
    alert('Checkout functionality will be implemented soon!');
  };

  if (loading && !cart) {
    return (
      <div className="container">
        <div className="card text-center">
          <h3>Loading your cart...</h3>
        </div>
      </div>
    );
  }

  if (!cart || !cart.items || cart.items.length === 0) {
    return (
      <div className="container">
        <div className="card">
          <div className="empty-cart">
            <div className="empty-cart-icon">🛒</div>
            <h2>Your cart is empty</h2>
            <p>Add some automotive parts to get started!</p>
            <button 
              onClick={handleContinueShopping}
              className="btn btn-primary"
            >
              Continue Shopping
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <div className="cart-header">
          <h1>Shopping Cart</h1>
          <div className="cart-actions">
            <button 
              onClick={handleContinueShopping}
              className="btn btn-secondary"
            >
              Continue Shopping
            </button>
            <button 
              onClick={handleClearCart}
              className="btn btn-danger"
              disabled={loading}
            >
              Clear Cart
            </button>
          </div>
        </div>

        <div className="cart-page-grid">
          <div>
            {cart.items.map(item => (
              <div key={item.id} className="card">
                <CartItem item={item} />
              </div>
            ))}
          </div>

          <div className="cart-summary-card">
            <div className="card">
              <h3>Order Summary</h3>
              
              <div className="summary-line">
                <span>Items ({summary.itemCount}):</span>
                <span>${summary.totalPrice.toFixed(2)}</span>
              </div>
              
              <div className="summary-line">
                <span>Shipping:</span>
                <span>Calculated at checkout</span>
              </div>
              
              <div className="summary-line">
                <span>Tax:</span>
                <span>Calculated at checkout</span>
              </div>
              
              <hr />
              
              <div className="summary-line total">
                <span>Total:</span>
                <span>${summary.totalPrice.toFixed(2)}</span>
              </div>

              <button 
                onClick={handleCheckout}
                className="btn btn-success checkout-btn"
                disabled={loading || cart.items.length === 0}
              >
                Proceed to Checkout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartPage;